<script setup>
import {nextTick, onActivated, onMounted, reactive, ref, watch} from "vue";
import {validateNumber} from "../../store/form_validate"
import {useSystem} from "../../store/system"
import {useUser} from "../../store/user"
import {base_url} from  '../../api/baseUrl'
import {useRoute} from "vue-router";

const userStore = useUser()
const systemStore = useSystem()
const route = useRoute()

onActivated(() => {
  //获取工单详情
  userStore.feedbackDetailApi(route.query.feedback_id, () => {
    setTimeout(() => {
      const container = document.querySelector('.scroll-custom');
      if(container){
        container.scrollTop = container.scrollHeight;
      }
    }, 1000)
  })
})

const submitLoading = ref(false)

const uploadImageUrl = ref('')

const handleUploadSuccess = (response, uploadFile, uploadFiles) => {
  // console.log(11111, response)
  // console.log(123123, uploadFile)
  // console.log(22222, uploadFiles)
  // uploadImageUrl.value = URL.createObjectURL(uploadFile.raw)
  imagePath.value = response.data.url
  sendMessage()
}

const message = ref('')
const imagePath = ref('')
const sendMessage = () => {
  if (message.value.length <= 0 && imagePath.value === '') return
  userStore.setFeedback({
    title: userStore.getFeedbackDetail.info?.title,
    feedback_id: userStore.getFeedbackDetail.info?.id,
    content: imagePath.value.length > 0? 'image' : message.value,
    image: imagePath.value
  })
  message.value = ''
  setTimeout(() => {
    userStore.feedbackDetailApi(userStore.getFeedbackDetail.info?.id, () => {
      setTimeout(() => {
        const container = document.querySelector('.scroll-custom');
        container.scrollTop = container.scrollHeight;
      }, 800)
    })
  }, 800)
}

</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg tw-p-4">
        <div class="tw-bottom-line tw-font-bold tw-text-[18px] bottom-line">
           <el-row class="tw-mb-3">
             <el-col :span="24" :md="16" :lg="16">
               <div class="tw-flex tw-justify-start tw-items-center">
                 <el-avatar class="tw-rounded-lg tw-flex-none" shape="square" :size="40" :src="userStore.getUserInfo.avatar" />
                 <div class="tw-ml-4">{{userStore.getFeedbackDetail.info?.title}}</div>
               </div>
             </el-col>
             <el-col :span="24" :md="8" :lg="8" class="tw-content-center tw-text-right">
               <div>Ticket No: #{{userStore.getFeedbackDetail.info?.id}}</div>
             </el-col>
           </el-row>
        </div>
        <div class="tw-h-[400px] tw-overflow-y-scroll scroll-custom">
          <div class="tw-mt-4" v-for="(item, index) in userStore.getFeedbackDetail.details" :key="index">
            <div class="tw-flex tw-justify-start tw-items-center" v-if="item.type == 1 && item.content != 'image'">
              <el-avatar class="tw-rounded-lg" shape="square" :size="40" :src="userStore.getUserInfo.avatar" />
              <div class="tw-relative tw-sjx-l tw-rounded-md tw-ml-4 !tw-bg-white !tw-bg-opacity-20 tw-py-2 tw-px-4">{{item.content}}</div>
            </div>
            <div class="tw-flex tw-justify-start tw-items-center" v-if="item.type == 1 && item.content == 'image'">
              <el-avatar class="tw-rounded-lg tw-flex-none" shape="square" :size="40" :src="userStore.getUserInfo.avatar" />
              <el-image :src="item.image" fit="cover" class="tw-w-[300px] tw-ml-4"></el-image>
            </div>
            <div class="tw-flex tw-justify-end tw-items-center" v-if="item.type == 2">
              <div class="tw-relative tw-sjx-r tw-rounded-md tw-mr-4 !tw-bg-white !tw-bg-opacity-20 tw-py-2 tw-px-4">{{item.content}}</div>
              <el-image class="tw-rounded-lg tw-w-[45px]" fit="cover" :src="systemStore.getWebsite.website_logo" />
            </div>
          </div>
        </div>
        <div class="tw-mt-4 tw-flex tw-justify-between tw-items-center tw-shadow-[inset_0_0_20px_0_rgba(0,0,0,0.25)] tw-rounded-lg tw-mt-4 tw-h-[50px]">
          <el-input type="text" v-model="message"></el-input>
          <div class="tw-flex tw-cursor-pointer tw-px-2">
            <el-upload
                :action="base_url+'/common/upload'"
                :headers="{token: userStore.getToken}"
                :data="{category: ''}"
                :show-file-list="false"
                :on-success="handleUploadSuccess"
            >
              <el-icon :size="30" class="tw-ml-1 tw-hover:tw-text-purple-500"><Paperclip /></el-icon>
            </el-upload>
            <el-icon :size="30" class="tw-ml-4 tw-hover:tw-text-purple-500" @click="sendMessage"><Promotion /></el-icon>
          </div>
        </div>

      </div>
    </el-col>
    <el-col :span="24" class="tw-mt-4">

    </el-col>
  </el-row>

</template>

<style lang="scss" scoped>
.scroll-custom::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
}

:deep(.el-input__wrapper) {
  background: transparent;
  height: 50px;
  box-shadow: none;

  .el-input__inner{
    color: #FFFFFF;
  }
}
.sjx-l::before{
  content: '';
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translate(-50%, -50%);
  border-width: 10px;
  border-style: solid;
  border-color: transparent rgba(255, 255, 255, 0.2) transparent transparent;
}
.sjx-r::before{
  content: '';
  position: absolute;
  right: -1.81rem;
  top: 50%;
  transform: translate(-50%, -50%);
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent transparent rgba(255, 255, 255, 0.2);
}

.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}

.custom-style .el-segmented {
  background: $p-bg-white-linear-active-color !important;
  color: $p-text-color !important;
  //--el-segmented-item-selected-bg-color: $p-tabs-hover-bg-color;
  --el-segmented-item-selected-bg-color: rgba(255,255,255, .4);

  .el-segmented__group{
    display: flex !important;
    flex-wrap: wrap !important;

    .el-segmented__item{
      min-height: 40px;

      &:hover{
        background: $p-tabs-hover-bg-color !important;
        color: $p-text-color;
      }

    }
  }
}

@media (max-width: 639px) {
  .el-segmented__item {
    border-bottom: 2px solid $p-border-color;
  }
}
</style>
